import { useMemo } from "react";

export const useFormHiddenInputs = (
  data: Record<string, string | number | boolean | undefined | null>
) =>
  useMemo(
    () =>
      Object.entries(data)
        .map(([k, v]) => [k, v?.toString()] as [string, string])
        .filter(([, value]) => value !== undefined),
    [data]
  );
